import React from 'react';
import { createRoot } from 'react-dom/client';
import OrganizationContacts from '../../src/organization_show/organization_contacts/organization_contacts';
import OrganizationJobs from '../../src/organization_show/organization_jobs/organization_jobs';
import { initSmoothScrollSections } from '../../src/organization_show/show';
import { addBackToTop, DEFAULT_SETTINGS } from '../../src/components/back_to_top/back_to_top';
import Tooltip from 'bootstrap/js/dist/tooltip';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';

document.addEventListener('DOMContentLoaded', () => {
  const containerContacts = document.getElementById('organization_contacts');
  const containerJobs = document.getElementById('jobs-section');

  if (containerContacts) {
    const rootContacts = createRoot(containerContacts);
    rootContacts.render(
      <DevexHighOrderComponent>
        <OrganizationContacts
          organizationName={containerContacts.getAttribute('organizationname')}
          organizationId={containerContacts.getAttribute('organizationid')}
          isAdmin={containerContacts.getAttribute('admin') === 'true'}
        />
      </DevexHighOrderComponent>
    );
  }

  if (containerJobs) {
    const rootJobs = createRoot(containerJobs);
    rootJobs.render(
      <DevexHighOrderComponent>
        <OrganizationJobs
          orgName={containerJobs.getAttribute('orgName')}
          isSignedIn={containerJobs.getAttribute('isSignedIn') === 'true'}
          viewExclusiveJobs={containerJobs.getAttribute('viewExclusiveJobs') === 'true'}
          membership={containerJobs.getAttribute('membership')}
          isAdmin={false}
        />
      </DevexHighOrderComponent>
    );
  }

  addBackToTop(DEFAULT_SETTINGS);
  initSmoothScrollSections();

  // Script to handle expanded/collapsed organization description if it is needed
  const expandDescriptionButton = document.getElementById('expand-description-btn');
  if (expandDescriptionButton) {
    const descriptionWrapper = document.getElementById('description-wrapper');
    // If the wrapped description is taller than its 5-line container
    if (descriptionWrapper.scrollHeight > descriptionWrapper.clientHeight) {
      // Stop hiding the Read more button
      document.getElementById('expand-description-btn-container').classList.remove('d-none');
    // If the wrapped description is short enough to fit in its container
    } else {
      // Remove the fade effect on the wrapped description
      descriptionWrapper.classList.remove('wrapped-description');
    }

    // Toggle between wrapped and expanded description on button click
    expandDescriptionButton.addEventListener('click', () => {
      if (descriptionWrapper.classList.contains('wrapped-description')) {
        descriptionWrapper.classList.remove('wrapped-description');
        descriptionWrapper.classList.add('expanded-description');
        expandDescriptionButton.textContent = 'Read less';
      } else {
        descriptionWrapper.classList.add('wrapped-description');
        descriptionWrapper.classList.remove('expanded-description');
        expandDescriptionButton.textContent = 'Read more';
      }
    });
  }

  // Enable Bootstrap tooltips
  const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltipElements.forEach((element) => new Tooltip(element));

  // Enable Bootstrap collapse offices if there are more than 3 offices
  const collapsibleContainer = document.querySelector('#collapsable-offices');
  if (collapsibleContainer) {
    const collapsibleButtonSpan = document.querySelector('.show-more-offices > span');
    const collapsibleButtonIcon = document.querySelector('.show-more-offices > i');
    const defaultButtonText = collapsibleButtonSpan.textContent;

    collapsibleContainer.addEventListener('show.bs.collapse', () => {
      collapsibleButtonSpan.innerText = 'Show less';
      collapsibleButtonIcon.className = 'fal icon-angle-up ms-1';
    });

    collapsibleContainer.addEventListener('hide.bs.collapse', () => {
      collapsibleButtonSpan.innerText = defaultButtonText;
      collapsibleButtonIcon.className = 'fal icon-angle-down ms-1';
    });
  }
});
